export const getConnectZoomButtonProps = (): any => ({
  'data-method': 'post',
  href: '/users/auth/zoom',
  target: 'auth_popup',
  onClick: () => window.open('about:blank', 'auth_popup', 'width=1000,height=800')
});
